import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  position: relative;

  .MuiTableRow-root.active {
    background: #fff;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);

    position: relative;
  }

  .actions-group {
    position: absolute;

    background: red;
  }

  .MuiButtonGroup-contained {
    margin-left: 1rem;
  }

  .loadingTable {
    position: absolute;
    top: calc(50% - 20px);
    left: calc(50% - 20px);

    z-index: 2;
  }

  .MuiTableRow-root.Mui-selected,
  .MuiTableRow-root.Mui-selected:hover {
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3) !important;
    background-color: #eaeaea !important;
  }

  ${(props) =>
    props.loading
      ? css`
          ::after {
            content: '';

            position: absolute;
            top: 0;
            left: 0;

            background: rgba(255, 255, 255, 0.4);

            width: 100%;
            height: 100%;

            z-index: 1;
          }
        `
      : ''}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  margin-bottom: 1rem;

  > button {
    margin-left: 1rem;
  }
`;
